import Link from 'components/link';

const notoSans = 'Noto Sans, sans-serif';

export const mantineTheme = {
  fontFamily: notoSans,
  headings: { fontFamily: notoSans },
  components: {
    Anchor: {
      defaultProps: {
        component: Link,
      },
    },
    Breadcrumbs: {
      styles: {
        root: { fontSize: '14px' },
        breadcrumb: { fontSize: '14px' },
        separator: { fontSize: '14px' },
      },
    },
    Badge: {
      defaultProps: {
        variant: 'light',
      },
    },
    LoadingOverlay: {
      defaultProps: {
        overlayProps: { bg: '#FFF', opacity: 0.5 },
      },
    },
    Popover: {
      defaultProps: {
        hideDetached: false,
      },
    },
    Portal: {
      defaultProps: {
        reuseTargetNode: false,
      },
    },
    Text: {
      defaultProps: {
        component: 'div',
      },
    },
    Title: {
      defaultProps: {
        component: 'div',
      },
    },
  },
};
